import React from "react";
import PropTypes from "prop-types";
// --- Import images
import AmexCard from "../../../../assets/images/amex_card.png";
import DiscoveryCard from "../../../../assets/images/discover_card.png";
import MastercardCard from "../../../../assets/images/mastercard_card.png";
import VisaCard from "../../../../assets/images/visa_card.png";
import JSBCard from "../../../../assets/images/jcb_card.png";
import GenericCard from "../../../../assets/images/generic_card.png";

import "./PaymentMethodsListItem.sass";

function PaymentMethodsListItem({
  cardData,
  id,
  cardType,
  lastFourDigits,
  exp,
  lastBillingTime,
  currentCard,
  handleSelectedCard,
  deletePaymentMethod,
}) {
  // ---- Function to get card image depending on card name
  function getCardImg(data) {
    const obj = {
      visa: VisaCard,
      mastercard: MastercardCard,
      amex: AmexCard,
      discover: DiscoveryCard,
      jcb: JSBCard,
    };
    return obj[data.toLowerCase()] || GenericCard;
  }
  function getCardTitle(data) {
    const obj = {
      visa: "VisaCard",
      mastercard: "MastercardCard",
      amex: "AmexCard",
      discover: "Discovery",
      jcb: "JCB",
    };
    return obj[data.toLowerCase()];
  }

  function convertDate(date) {
    // The date comes in seconds. Here I cheat on her in milliseconds
    const dateMs = new Date(date * 1000);
    const formatedDate = new Intl.DateTimeFormat(window.navigator.language)
      .format(dateMs)
      .replaceAll(".", "/");

    return formatedDate;
  }

  return (
    <li id={id} className="col-12">
      <section className="row align-items-center justify-content-between  payment-methods-list-item">
        <div className="col-auto d-flex flex-column flex-md-row align-items-start align-items-md-center payment-methods-list-item__cell">
          <div className="d-flex align-items-center payment-methods-list-item__card-wrapper">
            <label
              htmlFor={`card-${id}`}
              className={`payment-methods-list-item__radio-label ${
                currentCard.id === id
                  ? "payment-methods-list-item__radio-label--active"
                  : ""
              }`}
            >
              <input
                type="radio"
                id={`card-${id}`}
                name="payment-method"
                value={id}
                onChange={() => {
                  handleSelectedCard(cardData);
                }}
                checked={currentCard.id === id}
                className="payment-methods-list-item__radio-input"
              />
            </label>
            <img
              src={getCardImg(cardType)}
              alt=""
              className="payment-methods-list-item__img"
            />
            <h3 className="payment-methods-list-item__card-num">
              {getCardTitle(cardType)} •••• {lastFourDigits}
            </h3>
          </div>
          <div className="d-flex align-items-end payment-methods-list-item__card-details">
            <p className="payment-methods-list-item__exp">{exp}</p>
            {lastBillingTime !== "" && (
              <p className="payment-methods-list-item__last-billing">
                Last charged {convertDate(lastBillingTime)}
              </p>
            )}
          </div>
        </div>
        <div className="col-auto">
          <button
            aria-label="Delete payment method"
            className="payment-methods-list-item__delete-btn"
            onClick={() => {
              deletePaymentMethod(cardData);
            }}
          />
        </div>
      </section>
    </li>
  );
}

PaymentMethodsListItem.propTypes = {
  cardData: PropTypes.objectOf(PropTypes.any).isRequired,
  id: PropTypes.number.isRequired,
  cardType: PropTypes.string.isRequired,
  lastFourDigits: PropTypes.string.isRequired,
  exp: PropTypes.string.isRequired,
  lastBillingTime: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  currentCard: PropTypes.objectOf(PropTypes.any).isRequired,
  handleSelectedCard: PropTypes.func.isRequired,
  deletePaymentMethod: PropTypes.func.isRequired,
};

export default PaymentMethodsListItem;
